import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';

const styles = StyleSheet.create({
  headerContainer: {
    padding: 10,
    // borderBottomColor: '#C8C8C8',
    // borderBottomWidth: 1,
  },
  billTo: {
    // color: '#000',
    fontSize: 9,
  },
  cancellationpolicy: {
    // color: '#000',
    fontSize: 9,
    fontWeight: 100,
  },
});

// Cancellation modal function to handle various penalty types and their text format
let CancellationModal = (data, StartDate) => {
  let DataNew = '';
  let Value = '';
  let EuroIcon = '';
  let PerIcon = '';

  return (
    <Text>
      {data.map((i, index) => {
        const date = new Date(StartDate);
        date.setDate(date.getDate() - i.day_before_arrival);
        DataNew = moment(date).format('Do MMM YYYY');

        // Logic to determine the penalty details
        if (i.penalty === 'No Penalty') {
          Value = 0;
          EuroIcon = '';
          PerIcon = '';
        } else if (i.penalty === 'Full Amount') {
          Value = '';
          EuroIcon = '';
          PerIcon = 'Full booking amount will be charged.';
        } else if (i.penalty === 'Percentage') {
          Value = i.cancellation_value;
          EuroIcon = '';
          PerIcon = '% of booking amount will be charged.';
        } else if (i.penalty === 'Nights') {
          Value = i.cancellation_value;
          EuroIcon = '€';
          PerIcon = ' amount will be charged.';
        } else if (i.penalty === 'Fixed Amount') {
          Value = i.cancellation_value;
          EuroIcon = '€';
          PerIcon = ' amount will be charged.';
        }

        // Special case for no-show
        if (i.day_before_arrival === -1) {
          DataNew = 'No Show';
        }

        return (
          <Text key={index}>
            <Text style={{color:'red'}}>
              {index === 0 ? 'Before' : 'After'} {DataNew}
            </Text>
            <Text style={styles.cancellationpolicy}>
              {EuroIcon} {Value} {PerIcon}
            </Text>
          </Text>
        );
      })}
    </Text>
  );
};

const CancellationAccommodation = ({ invoice }) => {
  const startDate = invoice.booking_checked_in;
  const items1 = JSON.stringify(invoice?.cancellation_policy);
  const items2 = JSON.parse(items1);
  const items3 = JSON.parse(items2);

  const rowsCancel =
    items3 &&
    items3.slice(0, 1).map((item, index) => (
      <Text style={styles.billTo} key={index}>
        {CancellationModal(item, startDate)} <br />
      </Text>
    ));

  return (
    <View style={{backgroundColor:'#f5f5f5', padding:5, marginTop:5}}>
      <Text style={{fontSize:11, marginBottom:5,}}>Cancellation Policy: </Text>
      {rowsCancel}
    </View>
  );
};

export default CancellationAccommodation;
